import { Component, input, output } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-slide-toggle',
  imports: [MatSlideToggleModule, TranslatePipe],
  templateUrl: './slide-toggle.html',
  styleUrl: './slide-toggle.scss',
})
export class SlideToggle {
  readonly defaultToggleState = input<boolean>(false);
  readonly labels = input<{ labelFalse: string; labelTrue: string } | undefined>(undefined);

  onToggleSlide = output<boolean>();
}
